import type { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { Card, CardContent } from '@e2n/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type HinweisProps = {
  icon: IconDefinition;
  titel: string;
  beschreibung?: string;
  art?: 'neutral' | 'fehler';
  className?: string;
};

const FARBEN = {
  neutral: 'text-neutrals-700',
  fehler: 'text-primary-red-500',
} as const;

export function Hinweis({
  icon,
  titel,
  beschreibung,
  art = 'neutral',
  className,
}: HinweisProps) {
  return (
    <Card className={className}>
      <CardContent className="flex flex-col items-center gap-2 p-5 py-10">
        <FontAwesomeIcon icon={icon} size="xl" className={FARBEN[art]} />
        <p className="text-sm font-semibold text-neutrals-900">{titel}</p>
        {beschreibung && (
          <p className="text-sm text-neutrals-700">{beschreibung}</p>
        )}
      </CardContent>
    </Card>
  );
}

/** Hinweis als ganze Seite. */
export function SeitenHinweis(props: HinweisProps) {
  return (
    <div className="p-4 md:p-10 2xl:mx-auto 2xl:max-w-screen-2xl">
      <Hinweis {...props} />
    </div>
  );
}
